import React, {useEffect, useState} from 'react';
import {createRoot} from 'react-dom/client';
import PropTypes from "prop-types";

export function CsfMembreMonProfil({apiUrl, apiEnv}) {
  return (
    <div>
      TODO Mon profil https://jira.tink.ca/browse/T5537-3323
    </div>
  );
}

window.addEventListener('DOMContentLoaded', () => {
  const domNode = document.getElementById('CsfMembreMonProfil');
  if (domNode !== null) {
    const root = createRoot(domNode);

    const apiUrl = domNode.getAttribute("data-api-url");
    const apiEnv = domNode.getAttribute("data-api-env");

    root.render(<CsfMembreMonProfil
      apiUrl={apiUrl}
      apiEnv={apiEnv}
    />);
  }
});

CsfMembreMonProfil.propTypes = {
  apiUrl: PropTypes.string,
  apiEnv: PropTypes.string,
};
